import { createContext, useContext } from 'react';

// When true, every editing/mutating control in the object + inspection pages
// and their modals is hidden or disabled — used to render archived objects as
// a faithful, read-only mirror. Defaults to false, so live pages that don't
// provide it behave exactly as before.
export const ReadOnlyContext = createContext(false);

export const useReadOnly = () => useContext(ReadOnlyContext);
